import { render, staticRenderFns } from "./PopupReceipt.vue?vue&type=template&id=de1e0984"
import script from "./PopupReceipt.vue?vue&type=script&lang=js"
export * from "./PopupReceipt.vue?vue&type=script&lang=js"
import style0 from "./PopupReceipt.vue?vue&type=style&index=0&id=de1e0984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports